import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class DisputesService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (route.params.disputeId) {
      try {
        const resolved: any = {};
        const disputeId = route.params.disputeId;
        if (disputeId) {
          const respo: any = await this.getDisputeById(disputeId).catch(err => {
            console.error(err);
          });
          resolved.dispute = respo.payload;
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else if (route.params.communicationId) {
      try {
        const resolved: any = {};
        const communicationId = route.params.communicationId;
        if (communicationId) {
          const respo: any = await this.getDisputeById(communicationId).catch(err => {
            console.error(err);
          });
          resolved.communication = respo.payload;
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }

  }

  constructor(
    private api: ApiService,
    private router: Router
  ) {

  }

  // ok
  async newDispute(obj) {
    return this.api.postRequestPromise(`dispute`, obj);
  }

  // ok
  async newDisputeFromAgenda(obj) {
    return this.api.postRequestPromise(`dispute/fromAgenda`, obj);
  }

  // ok
  async newSingleVariation(obj) {
    return this.api.postRequestPromise(`dispute/variation/single`, obj);
  }

  // ok
  async newMultipleVariation(obj) {
    return this.api.postRequestPromise(`dispute/variation/multiple`, obj);
  }

  // ok
  async newChangeProfessor(obj) {
    return this.api.postRequestPromise(`dispute/changeProfessor`, obj);
  }

  async acceptSingleVariation(obj) {
    return this.api.putRequestPromise(`dispute/variation/single/accept`, obj);
  }

  async refuseSingleVariation(obj) {
    return this.api.putRequestPromise(`dispute/variation/single/refuse`, obj);
  }

  async acceptMultipleVariation(obj) {
    return this.api.putRequestPromise(`dispute/variation/multiple/accept`, obj);
  }

  async cancelMultipleVariationProposal(disputeId) {
    return this.api.putRequestPromise(`dispute/variation/multiple/cancel`, { id: disputeId });
  }

  async refuseMultipleVariation(obj) {
    return this.api.putRequestPromise(`dispute/variation/multiple/refuse`, obj);
  }
  async acceptDisputeFromAgenda(obj) {
    return this.api.putRequestPromise(`dispute/fromAgenda/accept`, obj);
  }

  async refuseDisputeFromAgenda(obj) {
    return this.api.putRequestPromise(`dispute/fromAgenda/refuse`, obj);
  }

  async cancelSingleVariationProposal(disputeId) {
    return this.api.putRequestPromise(`dispute/variation/single/cancel`, { id: disputeId });
  }

  async updateDispute(obj) {
    return this.api.putRequestPromise(`dispute`, obj);
  }

  async closeDispute(obj) {
    return this.api.putRequestPromise(`dispute/closed`, obj);
  }

  async getDisputesPaged(pageIndex, pageSize) {
    return this.api.getRequestPromise(`dispute?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }
  async getCommunicationByCurrentUserLoggedPaged(pageIndex, pageSize) {
    return this.api.getRequestPromise(`dispute/variations/byCurrentUserLogged?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async getDisputesByCurrentUserLoggedPaged(pageIndex, pageSize) {
    return this.api.getRequestPromise(`dispute/byCurrentUserLogged?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async getGenericOptionTypes(fromPage) {
    let url = `dispute/genericOptionTypes`;
    if (fromPage) {
      url += `?fromPage=${fromPage}`;
    }
    return this.api.getRequestPromise(url);
  }

  async getDisputeById(disputeId) {
    return this.api.getRequestPromise(`dispute/${disputeId}`);
  }

  async refuseChangeProfessor(obj) {
    return this.api.putRequestPromise(`dispute/changeProfessor/refuse`, obj);
  }

  async checkProposalChangeProfessor(obj) {
    return this.api.putRequestPromise(`dispute/changeProfessor/checkProposal`, obj);
  }

  async newProposalChangeProfessor(obj) {
    return this.api.putRequestPromise(`dispute/changeProfessor/newProposal`, obj);
  }

  async newProposalAcceptChangeProfessor(obj) {
    return this.api.putRequestPromise(`dispute/changeProfessor/newProposalAccept`, obj);
  }

}
